import { css } from '@emotion/react';
import { ContentBodyPadding, isPC, MaxContentBodySize, MaxEventBodySize } from 'constants/layout';

export const MaxContentBodyStyles = css`
  width: 100%;
  padding: 0 ${ContentBodyPadding}px;

  @media (${isPC}) {
    margin: 0 auto;
    max-width: ${MaxContentBodySize}px;
  }
`;

export const MaxEventBodyStyles = css`
  width: 100%;
  max-width: ${MaxEventBodySize}px;
  margin: 0 auto;
`;

export const SafeAreaTopStyles = (paddingTopPlus = 0) => css`
  padding-top: calc(${paddingTopPlus}px + var(--safe-area-top-old));
  padding-top: calc(${paddingTopPlus}px + var(--safe-area-top));
`;

export const SafeAreaBottomStyles = (paddingBottomPlus = 0) => css`
  padding-bottom: calc(${paddingBottomPlus}px + var(--safe-area-bottom-old));
  padding-bottom: calc(${paddingBottomPlus}px + var(--safe-area-bottom));
`;

export const ViewPortHeight = (height: number) => css`
  height: ${height ? `${height}px` : '100vh'};
`;

export const ViewPortMinHeight = (minHeight?: number) => css`
  min-height: ${minHeight !== undefined ? `${minHeight}px` : '100vh'};
`;
